import { render } from "./BlocoParceiros.vue?vue&type=template&id=cc9fe00c&scoped=true"
import script from "./BlocoParceiros.vue?vue&type=script&lang=js"
export * from "./BlocoParceiros.vue?vue&type=script&lang=js"

import "./BlocoParceiros.vue?vue&type=style&index=0&id=cc9fe00c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc9fe00c"]])

export default __exports__